export const NotFoundPage: React.FC = () => {
  window.location.href = process.env.REACT_APP_GENIAL_REDIRECT_URL ?? '';
  return null;
};
